import * as React from "react";
import { Stack, Text } from "office-ui-fabric-react";
// import Icon from "@mdi/react";

export interface PageTitleProps {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  title: string;
  description?: string;
}

class PageTitle extends React.Component<PageTitleProps> {
  size = this.props.description ? 48 : 32;
  render() {
    const TitleIcon = this.props.icon;
    return (
      <Stack horizontal verticalAlign="start">
        {TitleIcon && (
          <Stack.Item>
            {/* <Icon path={this.props.icon} style={{ fontSize: this.size, height: this.size, width: this.size, margin: 8 }} /> */}
            <TitleIcon
              role="img"
              aria-label="title-image"
              focusable="false"
              style={{ height: 44, width: 44 }}
            />
            {/* <FontIcon iconName={this.props.icon} style={{ fontSize: this.size, height: this.size, width: this.size, margin: 8 }} /> */}
          </Stack.Item>
        )}
        <Stack.Item className="ml-15">
          <Stack>
            <Stack.Item>
              <Text className="page-title">{this.props.title}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text className="page-title-description">
                {this.props.description}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    );
  }
}

export default PageTitle;
